import React from "react"
import { Box, Typography, Grid, Card, CardContent, useTheme, alpha } from "@mui/material"
import { CheckCircle } from "@mui/icons-material"
import { Conditional } from "src/shared/components"
import type { StepComponentProps } from "../types"
import { AUDIT_TYPES } from "../constants"

const AuditTypeSelection: React.FC<StepComponentProps> = ({ formData, onFieldChange }) => {
  const theme = useTheme()

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Choose Audit Type
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Select how you want to determine which products to audit
      </Typography>

      <Grid container spacing={2}>
        {AUDIT_TYPES.map((type) => (
          <Grid item xs={12} key={type.value}>
            <Card
              sx={{
                cursor: "pointer",
                border: `2px solid ${formData.type === type.value ? theme.palette.primary.main : "transparent"}`,
                backgroundColor: formData.type === type.value ? alpha(theme.palette.primary.main, 0.05) : "inherit",
                "&:hover": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.02),
                  border: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`
                },
                transition: "all 0.2s ease-in-out"
              }}
              onClick={() => onFieldChange("type", type.value)}
            >
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {type.icon}
                <Box flex={1}>
                  <Typography variant="subtitle1" fontWeight="medium">
                    {type.label}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {type.description}
                  </Typography>
                </Box>
                <Conditional condition={formData.type === type.value}>
                  <CheckCircle color="primary" />
                </Conditional>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default AuditTypeSelection
